import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

import { getNotificationPreferencesResponseSchema } from "./useGetNotifcationPreferences";

export const setNotificationPreferencesSchema = z.object({
  notificationPreference: z.object({
    key: z.string(),
    value: z.boolean().optional(),
  }),
});
export type SetNotificationPreferencesSchemaPayload = z.infer<
  typeof setNotificationPreferencesSchema
>;

const setNotificationPreferencesResponseSchema = getNotificationPreferencesResponseSchema;

type SetNotificationPreferencesResponse = z.infer<typeof setNotificationPreferencesResponseSchema>;

export function useSetNotificationPreferences(
  options: UseMutationOptions<
    SetNotificationPreferencesResponse,
    AxiosError,
    SetNotificationPreferencesSchemaPayload
  > = {}
): UseMutationResult<
  SetNotificationPreferencesResponse,
  AxiosError,
  SetNotificationPreferencesSchemaPayload
> {
  return useMutation({
    mutationFn: async (payload: SetNotificationPreferencesSchemaPayload) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/notificationPreferences/update`,
        data: payload,
        requestSchema: setNotificationPreferencesSchema,
        responseSchema: setNotificationPreferencesResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.SET_NOTIFICATION_PREFERENCES_FAILURE,
    },
    ...options,
  });
}
